module.exports = __webpack_public_path__ + "media/images/search_icon_white-745be8b4.svg";